// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-506e0aa3]:export{primaryColor:#00a68f;infoColor:#4f6475;headerBgColor:#000;headerTextColor:#131523;headerMenuActiveTextColor:#fff}.layout-loading[data-v-506e0aa3]{position:absolute;top:0;left:0;width:100%;height:100%;z-index:99}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
